<template>
    <TransitionRoot as="template" :show="show">
        <Dialog as="div" class="fixed inset-0 overflow-hidden" @close="close()">
            <div class="absolute inset-0 overflow-hidden">
                <DialogOverlay class="absolute inset-0 bg-gray-500 opacity-75"/>
                <div class="fixed inset-y-0 pl-16 max-w-full right-0 flex">
                    <TransitionChild as="template" enter="transform transition ease-in-out duration-500 sm:duration-700"
                        enter-from="translate-x-full" enter-to="translate-x-0"
                        leave="transform transition ease-in-out duration-500 sm:duration-700"
                        leave-from="translate-x-0" leave-to="translate-x-full">
                        <div class="w-screen">
                            <div class="h-full divide-y divide-gray-200 flex flex-col bg-white shadow-xl">
                                <div class="flex-1 h-0 overflow-y-auto">
                                    <div class="py-6 px-4  bg-gradient-to-b from-pitch-purple to-dark-pitch-purple sm:px-6">
                                        <div class="flex items-center justify-between">
                                            <DialogTitle class="text-lg text-white">
                                                {{ invoice.reference }} Breakdown
                                            </DialogTitle>
                                            <div class="ml-3 h-7 flex items-center">
                                                <button type="button"
                                                        class="bg-dark-pitch-purple rounded-md text-indigo-200 hover:text-white focus:outline-none focus:ring-2 focus:ring-white"
                                                        @click="close()">
                                                    <span class="sr-only">Close panel</span>
                                                    <XIcon class="h-6 w-6" aria-hidden="true"/>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="py-6 px-4 sm:px-6">
                                        <div class="flex">
                                            <input class="shadow-sm focus:ring-indigo-500 focus:border-light-pitch-purple block w-1/3 sm:text-sm border-gray-300 rounded-md" autocomplete="off" type="text" name="search"
                                                placeholder="Search..." v-model="form.search"/>
                                            <button class="text-sm text-gray-500 hover:text-gray-700 ml-4" type="button"
                                                    @click="reset()">Reset
                                            </button>
                                        </div>
                                        <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg mt-8">
                                            <table class="divide-y divide-gray-200">
                                                <thead class="bg-gray-50">
                                                    <tr>
                                                        <th scope="col"
                                                            class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                                            Invoice Reference
                                                        </th>
                                                        <th scope="col"
                                                            class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                                            Invoice Amount
                                                        </th>
                                                        <th scope="col"
                                                            class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                                            Management Fee Amount
                                                        </th>
                                                        <th scope="col"
                                                            class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider w-96">
                                                            Fixture Title
                                                        </th>
                                                        <th scope="col"
                                                            class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                                            Fixture Reference
                                                        </th>
                                                        <th scope="col"
                                                            class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                                            Quote Name
                                                        </th>
                                                        <th scope="col"
                                                            class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                                            Client Name
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(miri_invoice, index) in this.associatedInvoices" :key="index">
                                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                                            {{ miri_invoice.invoice.reference }}
                                                        </td>
                                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                                            {{ formatCurrency(miri_invoice.invoice.amount, miri_invoice.invoice.quote.sell_currency.code, true) }}
                                                        </td>
                                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                                            {{ formatCurrency(miri_invoice.amount, miri_invoice.invoice.quote.sell_currency.code, true) }}
                                                        </td>
                                                        <td class="px-6 py-4 text-sm text-gray-900 w-96">
                                                            {{ miri_invoice.invoice.quote.fixture.title }}
                                                        </td>
                                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                                            {{ miri_invoice.invoice.quote.fixture.reference }}
                                                        </td>
                                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                                            {{ miri_invoice.invoice.quote.name }}
                                                        </td>
                                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                                            {{ miri_invoice.invoice.quote.fixture.client.name }}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>
<script>
import debounce from 'lodash/debounce';
import {ref, reactive, computed} from 'vue'
import {XIcon} from '@heroicons/vue/outline';
import SearchFilter from "@/Components/SearchFilter";
import SlideOutErrors from "@/Components/SlideOutErrors";
import {Dialog, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot} from '@headlessui/vue';

export default {
    components: {
        XIcon,
        Dialog,
        DialogTitle,
        SearchFilter,
        DialogOverlay,
        SlideOutErrors,
        TransitionRoot,
        TransitionChild
    },
    data() {
        return {
            show: ref(false),
            invoice: null,
            associatedInvoices: null,
            form: {
                search: null
            }
        }
    },
    methods: {
        open(invoice) {
            this.show = true;
            this.invoice = invoice;
            this.associatedInvoices = this.fetchAssociatedInvoices(invoice);
        },
        close() {
            this.show = false;
        },
        fetchAssociatedInvoices() {
            axios.get(route('frontend.management-fees.get-invoice-breakdown', {invoice: this.invoice, search: this.form.search})).then(response => {
                this.associatedInvoices = response.data.associated_invoices;
            });
        },
        reset() {
            this.form.search = null;
        }
    },
    watch: {
        form: {
            deep: true,
            handler: debounce(function () {
                this.fetchAssociatedInvoices();
            }, 500),
        },
    },
}
</script>
